import { subscribe, unsubscribe, publish } from 'pubsub-js'
import { MenuRecord } from './storage'

const KEYS = {
  MSG_SLIDER_NAV: 'slider-nav',
  MSG_SIDER_WIDTH: 'sider-width',
  MSG_LOGIN_OK: 'login',
  MSG_LOGOUT_OK: 'logout',
  MSG_SINGUP_OK: 'singup',
  MSG_REDIR_SIGNUP: 'redirect-signup',
  MSG_HEADER_MENU: 'header-menu',
  MSG_MENU_MODULE: 'menu-module',
}

type Callback = ()=> void

// 注册订阅
export const subscribeSignup = (callback: Callback)=> subscribe(KEYS.MSG_SINGUP_OK, ()=> callback())
export const unsubscribeSignup = ()=> unsubscribe(KEYS.MSG_SINGUP_OK)
export const publishSignup = ()=> publish(KEYS.MSG_SINGUP_OK)

// 跳转注册页面
export const subscribeRedirectSingup = (callback: Callback)=> subscribe(KEYS.MSG_REDIR_SIGNUP, ()=> callback())
export const unsubscribeRedirectSignup = ()=> unsubscribe(KEYS.MSG_REDIR_SIGNUP)
export const publishRedirectSignup = ()=> publish(KEYS.MSG_REDIR_SIGNUP)

// 登录订阅
export const subscribeLogin = (callback: Callback)=> subscribe(KEYS.MSG_LOGIN_OK, ()=> callback())
export const unsubscribeLogin = ()=> unsubscribe(KEYS.MSG_LOGIN_OK)
export const publishLogin = ()=> publish(KEYS.MSG_LOGIN_OK)

// 退出订阅
export const subscribeLogout = (callback: Callback)=> subscribe(KEYS.MSG_LOGOUT_OK, ()=> callback())
export const unsubscribeLogout = ()=> unsubscribe(KEYS.MSG_LOGOUT_OK)
export const publishLogout = ()=> publish(KEYS.MSG_LOGOUT_OK)

// 侧栏订阅
export interface SliderNavData {
  menus: MenuRecord[]
  isInit: boolean
}
export const subscribeSliderNav = (callback: (data: SliderNavData)=> void)=> subscribe(KEYS.MSG_SLIDER_NAV, (_, data)=> callback(data))
export const unsubscribeSliderNav = ()=> unsubscribe(KEYS.MSG_SLIDER_NAV)
export const publishSliderNav = (data: SliderNavData)=> publish(KEYS.MSG_SLIDER_NAV, data)

// 侧栏宽度订阅
export const subscribeSliderWidth = (callback: (value: string)=> void)=> subscribe(KEYS.MSG_SIDER_WIDTH, (_, value)=> callback(value))
export const unsubscribeSliderWidth = ()=> unsubscribe(KEYS.MSG_SIDER_WIDTH)
export const publishSliderWidth = (data: string)=> publish(KEYS.MSG_SIDER_WIDTH, data)

// 顶部一级菜单
export const subscribeHeaderMenu = (callback: Callback)=> subscribe(KEYS.MSG_HEADER_MENU, ()=> callback())
export const unsubscribeHeaderMenu = ()=> unsubscribe(KEYS.MSG_HEADER_MENU)
export const publishHeaderMenu = ()=> publish(KEYS.MSG_HEADER_MENU)

// 顶部一级菜单
export const subscribeMenuModule = (callback: Callback)=> subscribe(KEYS.MSG_MENU_MODULE, ()=> callback())
export const unsubscribeMenuModule = ()=> unsubscribe(KEYS.MSG_MENU_MODULE)
export const publishMenuModule = ()=> publish(KEYS.MSG_MENU_MODULE)